import React from 'react';
import MyFlashcardsPage from '../user-creator/pages/MyFlashcardsPage';

interface CreateFlashcardsPageProps {
    onRegisterNewCollection?: (fn: () => void) => void;
}

const CreateFlashcardsPage: React.FC<CreateFlashcardsPageProps> = ({ onRegisterNewCollection }) => (
    <MyFlashcardsPage onRegisterNewCollection={onRegisterNewCollection} />
);

export default CreateFlashcardsPage;
